var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"echarts_show",attrs:{"id":"echarts_show"}})
}
var staticRenderFns = []

export { render, staticRenderFns }